const { API } = require('../../http');

const getWord = async (query) => {
  return await API.get(`/words?query=${query}`, {
    headers: { hideOverlay: true },
  });
};

const wordsServices = { getWord };

export default wordsServices;
